import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/tailwind.css'
import './assets/styles/theme.css'
import ToastPlugin from './utils/toast'

Vue.config.productionTip = false

// 注册 Toast 插件
Vue.use(ToastPlugin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
